import cx from 'classnames'
import Parser from 'html-react-parser'

import { FriendlyDateTime } from '../../../shared/Date/friendly-date-time'
import { useIGAO } from '../../context'
import { Domain } from '../../shared'
import {
  cancelledOrCompleted,
  diffDate,
  sortAction
} from '../../utils'

import styles from './comments-panel.module.scss'
import AddCommentIcon from './svgs/AddCommentIcon'

export const ItemIcon = ({ type, domain }) => {
  return (
    <div className={cx(styles.iconContainer, styles[type])}>
      {domain
        ? (
          <Domain domain={domain} />
        )
        : (
          <div className={cx(styles.action, styles.icon, styles[type])}>{type.substring(0, 1)}</div>
        )}
    </div>
  )
}

const CommentView = ({ comment, isMyComment }) => {
  return (
    <div>
      <div
        className={cx(styles.commentBlock, {
          [styles.draft]: comment.draft,
          [styles.right]: isMyComment,
          [styles.left]: !isMyComment,
          [styles.new]: comment.unread
        })}
        key={`${comment.id}-${comment.unread ? '1' : '2'}`}
      >
        <div className={styles.value}>
          <span>
            {comment.value}
          </span>
        </div>
      </div>
    </div>
  )
}

const Actions = ({
  actions,
  onOpen,
  commentRef,
  onKeyUp,
  onKeyDown,
  handleSave,
  setValue,
  value,
  open
}) => {
  const { pageData: { user: { id: userId } } } = useIGAO()
  const inlineDueDate = act =>
    Math.ceil(
      diffDate(
        act.dueDate,
        cancelledOrCompleted(act) ? act.statusChanged : null
      )
    )

  const myComment = act => act.author.id === userId

  return actions
    ? actions?.map(act => (
      <div
        className={styles.actionBody}
        key={act.id}
      >
        <div
          className={cx(styles.action, styles.header)}
        >
          <div className={styles.line} />
          <div
            className={styles.rpContent}
            style={{ zIndex: open === act.id ? 6 : 1 }}
          >
            <ItemIcon
              type={`action${inlineDueDate(act) > 0 ? 'Active' : 'Ended'}`}
            />
            <div className={styles.itemTitle}>
              {act && Parser(act?.description ?? '')}
            </div>
            <div className={styles.addIconContainer}>
              <button
                onClick={() => onOpen(act.id)}
                style={{
                  position: 'relative',
                  zIndex: open === act.id ? 6 : 1
                }}
              >
                <AddCommentIcon />
              </button>

              {open === act.id && (
                <div
                  ref={commentRef}
                  className={styles.commentContainer}
                >
                  <div className={styles.textareaContainer}>
                    <textarea
                    /* eslint-disable-next-line jsx-a11y/no-autofocus */
                      autoFocus
                      onKeyUp={onKeyUp}
                      onKeyPress={e => handleSave(e, 'action')}
                      onKeyDown={onKeyDown}
                      value={value}
                      onChange={v => setValue(v.target.value)}
                    />
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        <div className={styles.rpCommentContainer}>
          {act?.comment
            ?.sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt))
            .map(com => {
              const isMyComment = myComment(com)
              return (
                <div key={com.id}>
                  <CommentView
                    key={com.id}
                    comment={com}
                    isMyComment={isMyComment}
                  />
                  <div
                    className={cx(styles.footer, {
                      [styles.right]: isMyComment,
                      [styles.left]: !isMyComment
                    })}
                  >
                    {com.author?.name || 'Compassion System'}
                    <FriendlyDateTime datetime={com.createdAt.toString()} />
                  </div>
                </div>
              )
            })}
        </div>
      </div>
    ))
    : null
}

export function Treeview ({
  item,
  onOpen,
  commentRef,
  onKeyUp,
  onKeyDown,
  handleSave,
  setValue,
  value,
  open
}) {
  const { pageData: { user: { id: userId } } } = useIGAO()
  const myComment = act => act?.author?.id === userId
  return (
    <div className={styles.treeviewContainer}>
      <div style={{ borderLeft: '1px solid #979797' }}>
        <div className={styles.issueBody}>
          <div className={cx(styles.issue, styles.header)}>
            <ItemIcon
              type='issue'
              domain={item.domain}
            />
            <div
              className={styles.value}
              style={{ width: '100%' }}
            >
              {item && Parser(item?.description)}
            </div>
            <div
              className={styles.addIconContainer}
              style={{ zIndex: open === item.id ? 6 : 1 }}
            >
              <button
                onClick={() => onOpen(item.id)}
                style={{
                  position: 'relative',
                  zIndex: 6
                }}
              >
                <AddCommentIcon />
              </button>
              {open === item.id && (
                <div
                  ref={commentRef}
                  className={styles.commentContainer}
                >
                  <div className={styles.textareaContainer}>
                    <textarea
                      /* eslint-disable-next-line jsx-a11y/no-autofocus */
                      autoFocus
                      onKeyUp={onKeyUp}
                      onKeyPress={e => handleSave(e, 'issue')}
                      onKeyDown={onKeyDown}
                      value={value}
                      onChange={v => setValue(v.target.value)}
                    />
                  </div>
                </div>
              )}
            </div>
          </div>
          <div className={styles.rpCommentContainer}>
            {item?.comment
              ?.sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt))
              .map(com => {
                const isMyComment = myComment(com)
                return (
                  <div key={com.id}>
                    <CommentView
                      key={com.id}
                      comment={com}
                      isMyComment={isMyComment}
                    />
                    <div
                      className={cx(styles.footer, {
                        [styles.right]: isMyComment,
                        [styles.left]: !isMyComment
                      })}
                    >
                      {com.author?.name || 'Compassion System'}
                      <FriendlyDateTime datetime={com.createdAt.toString()} />
                    </div>
                  </div>
                )
              })}
          </div>
          <Actions
            actions={sortAction(item?.actions)}
            onOpen={onOpen}
            commentRef={commentRef}
            onKeyUp={onKeyUp}
            onKeyDown={onKeyDown}
            handleSave={handleSave}
            setValue={setValue}
            value={value}
            open={open}
          />
        </div>
      </div>
    </div>
  )
}
